import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "FoerdermittelModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {
        mib_mittel: 0,
      },
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "mib_kbez",
            type: "text",
            label: "_LBL_FOERDERMITTEL_MODAL_CREATE_NAME_",
            required: true,
            view: "v",
            translate: true,
          },
          {
            id: "mib_kennung",
            type: "text",
            label: "_LBL_FOERDERMITTEL_MODAL_CREATE_KENNUNG_",
            required: true,
            view: "v",
            translate: true,
          },
          {
            id: "mib_mittel",
            type: "currency",
            label: "_LBL_FOERDERMITTEL_MODAL_CREATE_MITTEL_",
            maxlength: 20,
            view: "v",
            translate: true,
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: `foerdermittel/`, data }).then(
        () => {
          this.addNotification({ text: "_MSG_FOERDERMITTEL_MODAL_CREATE_SUCCESS_" });
          this.close({ status: true });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
